import { ref } from 'vue';

export const fetchData = async (url) => {
    const fetchData = ref(undefined);
    const isPending = ref(false);
    const errorMessage = ref(null);

    const controller = new AbortController();

    try {
        isPending.value = true;
        const res = await fetch(url, { signal: controller.signal });

        if (!res.ok) {
            throw new Error(res.statusText);
        }

        const data = await res.json();

        fetchData.value = data;
        isPending.value = false;
        errorMessage.value = null;
    } catch (err) {
        if (err instanceof Error) {
            if (err.name === 'AbortError') {
                errorMessage.value = `The fetch was aborted: ${err.message}`;
            } else {
                isPending.value = false;
                errorMessage.value = err.message;
            }
        }
    } finally {
        isPending.value = false;
    }

    return { result: fetchData.value, pending: isPending.value, error: errorMessage.value };
};
